import React from 'react';

const Logo = ({ 
  showText = true, 
  size = 'default',
  className = '',
  variant = 'full', // 'full' | 'compact'
  darkTheme = false
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    large: 'w-12 h-12'
  };

  const textSizes = {
    small: { title: 'text-base', subtitle: 'text-xs' },
    default: { title: 'text-xl', subtitle: 'text-xs' },
    large: { title: 'text-2xl', subtitle: 'text-sm' }
  };

  const iconContent = (
    <svg 
      className="w-6 h-6 text-white" 
      viewBox="0 0 24 24" 
      fill="currentColor"
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
  );

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex-shrink-0">
        <div 
          className={`rounded-xl flex items-center justify-center ${sizeClasses[size]} shadow-glow`}
          style={{
            background: 'linear-gradient(135deg, #00d4ff, #0066ff)',
            boxShadow: '0 8px 32px rgba(0, 212, 255, 0.2)'
          }}
        >
          <span className="text-white font-black text-sm tracking-wider">
            ECP
          </span>
        </div>
      </div>
      {showText && (
        <div>
          <h1 className={`font-extrabold tracking-tight ${
            darkTheme ? 'text-primary-light' : 'text-gray-900'
          } ${textSizes[size].title}`}>
            ECP Capital
          </h1>
          {variant === 'full' && (
            <p className={`font-medium ${
              darkTheme ? 'text-text-muted' : 'text-gray-500'
            } ${textSizes[size].subtitle}`}>
              Backoffice System
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;